export default __webpack_public_path__ + "static/white-gravel-bananatex-f09a4b817de9a15b53ad9fbedc1e59bb.png";